import { DriverSettlementProfile } from "../DriverSettlementProfile";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutDriverSettlementProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: DriverSettlementProfile;
    panelHeader: Panel;
    sourceDriverSettlementProfile: DataSource;
}
